<template>
  <div class="container mt-4">
    <div class="card shadow-sm p-4 bg-light">
      <div class="d-flex align-items-center mb-4">
        <button class="btn btn-outline-secondary me-3" @click="volver">
          ← Regresar
        </button>
        <h3 class="m-0 flex-grow-1 text-center">Clientes en Lista de Espera</h3>
        <button class="btn btn-success ms-auto" @click="mostrarModal = true">
          + Agregar Cliente
        </button>
      </div>

      <div v-if="lista.length === 0" class="text-center text-muted">
        No hay clientes en lista de espera.
      </div>

      <div v-for="cliente in lista" :key="cliente.IdListaEspera" class="card mb-3 shadow-sm">
        <div class="card-body">
          <p><strong>Nombre:</strong> {{ cliente.NombreCliente }} {{ cliente.ApellidoCliente }}</p>
          <p><strong>Teléfono:</strong> {{ cliente.Telefono }}</p>
          <p><strong>Correo:</strong> {{ cliente.Correo}}</p>
          <p><strong>Fecha Entrada:</strong> {{ cliente.FechaEntrada }}</p>
          <p><strong>Fecha Salida:</strong> {{ cliente.FechaSalida }}</p>
          <p><strong>Descripción:</strong> {{ cliente.Descripcion || '---' }}</p>
          
          

          <div class="d-flex justify-content-end">
            <button class="btn btn-primary" @click="cambiarEstado(cliente.IdListaEspera)">
             Quitar Cliente En Espera
            </button>
          </div>
        </div>
      </div>

      <!-- Modal de agregar cliente -->
      <div v-if="mostrarModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Agregar a Lista de Espera</h5>
              <button type="button" class="btn-close" @click="cerrarModal"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="agregarCliente">
                <div class="mb-3">
                  <label class="form-label">Nombre del Cliente</label>
                  <input type="text" class="form-control" v-model="nuevoCliente.NombreCliente" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Apellido del Cliente</label>
                  <input type="text" class="form-control" v-model="nuevoCliente.ApellidoCliente" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Teléfono</label>
                  <input type="text" class="form-control" v-model="nuevoCliente.Telefono" required />
                </div>
                 <div class="mb-3">
                  <label class="form-label">Correo:</label>
                  <input type="text" class="form-control" v-model="nuevoCliente.Correo" />
                </div>
                <div class="mb-3">
                  <label class="form-label">Fecha Entrada</label>
                  <input type="date" class="form-control" v-model="nuevoCliente.FechaEntrada" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Fecha Salida</label>
                  <input type="date" class="form-control" v-model="nuevoCliente.FechaSalida" required />
                </div>
                <div class="mb-3">
                  <label class="form-label">Descripción</label>
                  <textarea class="form-control" v-model="nuevoCliente.Descripcion"></textarea>
                </div>
                <button type="submit" class="btn btn-success w-100">Guardar</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055;">
        <div class="toast show text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i> {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { API_URL } from '@/config/config.js'
import { mapActions } from 'vuex'

export default {
  name: 'ListaEsperaView',
  data() {
    return {
      lista: [],
      alerta: { mensaje: '', tipo: 'success' },
      mostrarToast: false,
      mostrarModal: false,
      nuevoCliente: {
        NombreCliente: '',
        ApellidoCliente: '',
        Telefono: '',
        FechaEntrada: '',
        FechaSalida: '',
        Descripcion: '',
        Correo:'',
      }
    }
  },
  async mounted() {
    await this.obtenerLista();
  },
  methods: {
    ...mapActions(['fetchTotalPendientes']), // 🧠 importa la acción del store

    async obtenerLista() {
      try {
        const res = await axios.get(`${API_URL}/clientes-en-espera`)
        this.lista = res.data
      } catch (error) {
        this.mostrarToastMensaje('Error al cargar la lista', 'danger')
      }
    },
    async cambiarEstado(id) {
      try {
        await axios.put(`${API_URL}/actualizar-lista/${id}`)
        this.mostrarToastMensaje('Estado actualizado')
        await this.obtenerLista()
        await this.fetchTotalPendientes() // 🔄 actualiza el contador del sidebar
      } catch (error) {
        this.mostrarToastMensaje('Error al cambiar estado', 'danger')
      }
    },
    async agregarCliente() {
      try {
        await axios.post(`${API_URL}/clientes-en-espera`, this.nuevoCliente)
        this.mostrarToastMensaje('Cliente agregado correctamente')
        this.cerrarModal()
        await this.obtenerLista()
        await this.fetchTotalPendientes() // 🔄 actualiza el contador del sidebar
      } catch (error) {
        this.mostrarToastMensaje('Error al agregar cliente', 'danger')
      }
    },
    cerrarModal() {
      this.mostrarModal = false
      this.nuevoCliente = {
        NombreCliente: '',
        ApellidoCliente: '',
        Telefono: '',
        FechaEntrada: '',
        FechaSalida: '',
        Descripcion: '',
        Correo:'',
      }
    },
    mostrarToastMensaje(mensaje, tipo = 'success') {
      this.alerta.mensaje = mensaje
      this.alerta.tipo = tipo
      this.mostrarToast = true
      setTimeout(() => {
        this.mostrarToast = false
      }, 3000)
    },
    cerrarToast() {
      this.mostrarToast = false
    },
    volver() {
      this.$router.push('/inicio')
    }
  },
  computed: {
    toastColor() {
      return {
        success: 'bg-success',
        danger: 'bg-danger',
        warning: 'bg-warning text-dark',
        info: 'bg-info text-dark'
      }[this.alerta.tipo] || 'bg-primary'
    },
    iconoToast() {
      return {
        success: 'bi bi-check-circle-fill',
        danger: 'bi bi-x-circle-fill',
        warning: 'bi bi-exclamation-triangle-fill',
        info: 'bi bi-info-circle-fill'
      }[this.alerta.tipo] || 'bi bi-info-circle-fill'
    }
  }
}
</script>


<style scoped>
label {
  font-weight: 500;
}
</style>
